<div class="pt-36 md:pt-40 w-4/5 mx-auto">
    <div @slideDown>
        <app-text class="text-center text-4xl md:text-7xl font-black" [value]="'Наплата'"></app-text>
    </div>
    <div class="grid md:grid-cols-2 pt-3 md:mt-10">
        <!--        information's for delivery form-->
        <form [formGroup]="order">
            <hr class="h-px my-2 bg-gray-400 border-0">
            <app-text class="text-left md:text-3xl font-bold" [value]="'ИНФОРМАЦИИ ЗА ДОСТАВАТА'"></app-text>
            <div class="grid md:grid-cols-2 gap-5 pt-10">
                <div class="space-y-5">
                    <div>
                        <app-text-input [floatLabel]="true"
                                        [label]="'Име'"
                                        [control]="nameControl"
                                        [autocomplete]="'given-name'"
                                        [type]="'text'"></app-text-input>
                    </div>
                    <div>
                        <app-text-input [floatLabel]="true"
                                        [label]="'Презиме'"
                                        [control]="surnameControl"
                                        [autocomplete]="'family-name'"
                                        [type]="'text'"></app-text-input>
                    </div>
                    <div>
                        <app-text-input [floatLabel]="true"
                                        [label]="'Телефонски Број'"
                                        [control]="phoneNumberControl"
                                        [autocomplete]="'tel'"
                                        [inputmode]="'tel'"
                                        [type]="'tel'"></app-text-input>
                    </div>
                    @if (customer?.currentPoints!) {
                        <div>
                            <app-text [value]="'Поени: ' + customer?.currentPoints"></app-text>
                            <app-checkbox
                                    [label]="'Искористи поени'"
                                    (checkboxChange)="handleCheckboxChange($event)"
                            ></app-checkbox>
                        </div>
                    }
                </div>
                <div class="space-y-5">
                    <div class="relative" data-autocomplete="place">
                        <p class="mb-1 block text-left text-sm font-medium text-gray-700">Место</p>
                        <input type="text"
                               formControlName="placeInput"
                               (focus)="onPlaceFocus()"
                               (keydown)="onPlaceKeydown($event)"
                               placeholder="Внеси град или населено место..."
                               autocomplete="off"
                               role="combobox"
                               aria-autocomplete="list"
                               [attr.aria-expanded]="isPlaceDropdownOpen"
                               aria-controls="place-listbox"
                               class="w-full rounded-xl border bg-white px-3 py-2.5 text-sm text-gray-900 outline-none transition focus:border-black focus:ring-2 focus:ring-black/5"
                               [ngClass]="placeError ? 'border-red-400 focus:border-red-500 focus:ring-red-100' : 'border-gray-300'"/>

                        @if (isPlaceDropdownOpen) {
                            <div id="place-listbox"
                                 role="listbox"
                                 class="absolute z-20 mt-1 max-h-56 w-full overflow-auto rounded-xl border border-gray-200 bg-white p-1 shadow-lg">
                                @if (isSearchingPlaces) {
                                    <div class="px-3 py-2 text-left text-sm text-gray-500">Се пребаруваат места...</div>
                                } @else if (placeOptions.length === 0 && (placeInputControl.value?.length ?? 0) > 1) {
                                    <div class="px-3 py-2 text-left text-sm text-gray-500">Нема пронајдени места.</div>
                                } @else {
                                    @for (place of placeOptions; track place.id; let i = $index) {
                                        <button type="button"
                                                role="option"
                                                [attr.aria-selected]="i === activePlaceIndex"
                                                (click)="selectPlace(place)"
                                                class="flex w-full items-center rounded-lg px-3 py-2 text-left text-sm transition"
                                                [ngClass]="i === activePlaceIndex ? 'bg-gray-100 text-gray-900' : 'text-gray-700 hover:bg-gray-50'">
                                            <span class="min-w-0 truncate">
                                                {{ place.name }}
                                                @if (place.region) {
                                                    <span class="text-gray-500">({{ place.region }})</span>
                                                }
                                            </span>
                                        </button>
                                    }
                                }
                            </div>
                        }

                        @if (placeError) {
                            <p class="mt-1 text-left text-xs text-red-600">{{ placeError }}</p>
                        }
                    </div>

                    <div class="relative" data-autocomplete="street">
                        <p class="mb-1 block text-left text-sm font-medium text-gray-700">Улица</p>
                        <input type="text"
                               formControlName="streetInput"
                               (focus)="onStreetFocus()"
                               (blur)="onStreetBlur()"
                               (keydown)="onStreetKeydown($event)"
                               placeholder="Внеси или избери улица..."
                               autocomplete="off"
                               role="combobox"
                               aria-autocomplete="list"
                               [attr.aria-expanded]="isStreetDropdownOpen"
                               aria-controls="street-listbox"
                               class="w-full rounded-xl border bg-white px-3 py-2.5 text-sm text-gray-900 outline-none transition focus:border-black focus:ring-2 focus:ring-black/5 disabled:cursor-not-allowed disabled:bg-gray-100 disabled:text-gray-400"
                               [ngClass]="streetError ? 'border-red-400 focus:border-red-500 focus:ring-red-100' : 'border-gray-300'"/>

                        @if (isStreetDropdownOpen && selectedPlaceIdControl.value) {
                            <div id="street-listbox"
                                 role="listbox"
                                 class="absolute z-20 mt-1 max-h-56 w-full overflow-auto rounded-xl border border-gray-200 bg-white p-1 shadow-lg">
                                @if (isSearchingStreets) {
                                    <div class="px-3 py-2 text-left text-sm text-gray-500">Се пребаруваат улици...</div>
                                } @else {
                                    @for (street of streetOptions; track street.id; let i = $index) {
                                        <button type="button"
                                                role="option"
                                                [attr.aria-selected]="i === activeStreetIndex"
                                                (mousedown)="$event.preventDefault()"
                                                (click)="selectStreet(street)"
                                                class="w-full rounded-lg px-3 py-2 text-left text-sm transition"
                                                [ngClass]="i === activeStreetIndex ? 'bg-gray-100 text-gray-900' : 'text-gray-700 hover:bg-gray-50'">
                                            {{ street.name }}
                                        </button>
                                    }
                                }
                            </div>
                        }

                        @if (streetError) {
                            <p class="mt-1 text-left text-xs text-red-600">{{ streetError }}</p>
                        }
                    </div>

                    <div class="grid grid-cols-3 gap-3">
                        <div>
                            <p class="mb-1 block text-left text-sm font-medium text-gray-700">Број</p>
                            <input type="text"
                                   formControlName="houseNumber"
                                   placeholder="пр. 15А"
                                   class="w-full rounded-xl border bg-white px-3 py-2.5 text-sm text-gray-900 outline-none transition focus:border-black focus:ring-2 focus:ring-black/5"
                                   [ngClass]="houseNumberError ? 'border-red-400 focus:border-red-500 focus:ring-red-100' : 'border-gray-300'"/>
                            @if (houseNumberError) {
                                <p class="mt-1 text-left text-xs text-red-600">{{ houseNumberError }}</p>
                            }
                        </div>
                        <div>
                            <p class="mb-1 block text-left text-sm font-medium text-gray-700">Влез (опц.)</p>
                            <input type="text"
                                   formControlName="entrance"
                                   placeholder="пр. 2"
                                   class="w-full rounded-xl border border-gray-300 bg-white px-3 py-2.5 text-sm text-gray-900 outline-none transition focus:border-black focus:ring-2 focus:ring-black/5"/>
                        </div>
                        <div>
                            <p class="mb-1 block text-left text-sm font-medium text-gray-700">Стан (опц.)</p>
                            <input type="text"
                                   formControlName="apartment"
                                   placeholder="пр. 12"
                                   class="w-full rounded-xl border border-gray-300 bg-white px-3 py-2.5 text-sm text-gray-900 outline-none transition focus:border-black focus:ring-2 focus:ring-black/5"/>
                        </div>
                    </div>
                    <div>
                        <app-text-input [floatLabel]="true"
                                        [label]="'Е-маил адреса'"
                                        [control]="emailControl"
                                        [autocomplete]="'email'"
                                        [type]="'email'"></app-text-input>
                    </div>
                </div>
            </div>
            <div class="py-5 md:pt-10">
                <!-- Phones show the order summary below the form, so the total goes next to the button. -->
                @if (orderItems.length > 0) {
                    <div class="md:hidden flex justify-between items-baseline border-t border-gray-300 pt-3 pb-4 text-left">
                        <span class="text-gray-700">Вкупно за плаќање</span>
                        <span class="text-xl font-medium text-gray-900">{{ usePointsControl.value === true ? (customer?.currentPoints! > totalPrice ? 0 : totalPrice - customer?.currentPoints!) : totalPrice }} ден.</span>
                    </div>
                }
                <app-primary-button
                        [value]="'КУПИ СЕГА'"
                        [isLoading]="isLoading"
                        (click)="openConfirmationModal()"></app-primary-button>
                <ul class="pt-3 list-none pl-0 space-y-1 text-left text-sm text-gray-700">
                    <li><span class="text-primaryDark font-bold" aria-hidden="true">✓</span> Плаќате во готово дури кога ќе ја примите пратката</li>
                    <li><span class="text-primaryDark font-bold" aria-hidden="true">✓</span> Достава низ цела Македонија за 2–7 работни дена</li>
                    <li><span class="text-primaryDark font-bold" aria-hidden="true">✓</span> Прашања? 073/857-133 (и Viber)</li>
                </ul>
            </div>
        </form>

        <!--        Order items overview-->
        <div class="md:pl-20 pb-14">
            <div class="bg-gray-200 p-5 ">
                <div class="flex justify-between pb-2">
                    <app-text class="my-auto text-left lg:text-xl font-semibold"
                              [value]="'Преглед на нарачката:'"></app-text>
                    @if (orderItems.length > 0) {
                        <app-primary-button [class]="'lg:text-xl'" [value]="'измени нарачка'"
                                            (click)="goToUrl(router, '/cart')"></app-primary-button>
                    }
                </div>
                <hr class="h-px my-2 bg-gray-800 border-0">
                <app-text class="lg:text-xl font-medium"
                          [value]="orderItems.length + (orderItems.length === 1 ? ' Производ' : ' Производи')"></app-text>

                @for (orderItem of orderItems; track orderItem) {

                    <div class="flex justify-between pt-2">
                        <div class="flex">
                            <app-image [class]="'w-20 lg:w-24 max-w-24'"
                                       [src]="orderItem.product!.images[0]"
                                       [alt]="orderItem.product!.altImages[0]"></app-image>
                            <div class="pl-2 my-auto text-sm lg:text-base text-left max-w-40 lg:max-w-72">
                                <app-text
                                        [value]="orderItem?.quantity + ' X ' + orderItem?.product?.name"></app-text>
                            </div>
                        </div>
                        <app-text class="my-auto text-right max-w-10 lg:max-w-full"
                                  [value]="(orderItem?.product?.price ?? 0) * (orderItem?.quantity ?? 0) + ' ден.'"></app-text>
                    </div>
                }
                <hr class="h-px my-2 bg-gray-800 border-0">
                @if (orderItems.length > 0) {
                    <div class="pb-3"><app-free-delivery-progress [orderPrice]="orderPrice"></app-free-delivery-progress></div>
                    @if (isCouponCodeUsed) {
                        <app-text class="text-right text-red-500"
                                  [value]="'Попуст: 10% &darr;'"></app-text>
                        <app-text class="text-right text-lg font-medium line-through"
                                  [value]="'ВКУПНО: ' + oldPrice + ' ден.'"></app-text>
                    }
                    @if (usePointsControl.value === true) {
                        <app-text class="text-right text-red-500"
                                  [value]="'Попуст: ' +  ((customer?.currentPoints! > totalPrice )?totalPrice: (customer?.currentPoints!)) + ' ден.   '"></app-text>

                    }
                    @if (usePointsControl.value === false) {
                        <app-text [ngClass]="isCouponCodeUsed? 'text-red-500' :''"
                                  class="text-right text-lg font-medium"
                                  [value]="'ВКУПНО: ' + totalPrice + ' ден.'"></app-text>
                    }
                    @if (usePointsControl.value === true) {
                        <app-text class="text-right text-lg font-medium line-through"
                                  [value]="'ВКУПНО: ' + totalPrice + ' ден.'"></app-text>
                        <app-text class="text-right text-lg font-medium text-red-500"
                                  [value]="'ВКУПНО: ' + ((customer?.currentPoints! > totalPrice )?0: (totalPrice-customer?.currentPoints!))  + ' ден.'"></app-text>
                    }
                }
            </div>
        </div>
    </div>
    <app-confirmation-modal (confirmationEvent)="submitOrder()"></app-confirmation-modal>
    <app-toast
            [message]="toastMessage"
    ></app-toast>
</div>